/*
 * Botao de tela cheia nos videos UGC da pagina de produto.
 *
 * Os controles nativos do navegador nem sempre mostram fullscreen em cards
 * estreitos no mobile. Este botao usa a Fullscreen API no desktop e
 * webkitEnterFullscreen no iOS.
 */
if (!customElements.get('videos-br-media')) {
  customElements.define(
    'videos-br-media',
    class VideosBrMedia extends HTMLElement {
      connectedCallback() {
        this.deferred = this.querySelector('deferred-media');
        if (!this.deferred) return;

        this.rotuloTelaCheia = this.dataset.labelFullscreen || 'Tela cheia';
        this.rotuloSair = this.dataset.labelExit || 'Sair da tela cheia';
        const raiz = this.closest('.videos-br');
        this.iconeEntrar = raiz?.querySelector('.videos-br__icone-entrar')?.innerHTML || '';
        this.iconeSair = raiz?.querySelector('.videos-br__icone-sair')?.innerHTML || '';

        this.observador = new MutationObserver(() => this.prepararVideo());
        this.observador.observe(this.deferred, {
          attributes: true,
          attributeFilter: ['loaded'],
          childList: true,
          subtree: true,
        });

        this.sincronizarTelaCheia = this.sincronizarTelaCheia.bind(this);
        document.addEventListener('fullscreenchange', this.sincronizarTelaCheia);
        document.addEventListener('webkitfullscreenchange', this.sincronizarTelaCheia);
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        document.removeEventListener('fullscreenchange', this.sincronizarTelaCheia);
        document.removeEventListener('webkitfullscreenchange', this.sincronizarTelaCheia);
      }

      prepararVideo() {
        const video = this.deferred.querySelector('video');
        if (!video || video.dataset.videosBrPronto) return;
        video.dataset.videosBrPronto = 'true';

        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        const botao = document.createElement('button');
        botao.type = 'button';
        botao.className = 'videos-br__tela-cheia';
        botao.setAttribute('aria-label', this.rotuloTelaCheia);
        botao.innerHTML = `<span class="videos-br__tela-cheia-icone videos-br__tela-cheia-icone--entrar" aria-hidden="true">${this.iconeEntrar}</span><span class="videos-br__tela-cheia-icone videos-br__tela-cheia-icone--sair hidden" aria-hidden="true">${this.iconeSair}</span>`;

        botao.addEventListener('click', (evento) => {
          evento.preventDefault();
          evento.stopPropagation();
          this.alternarTelaCheia(video);
        });

        this.botaoTelaCheia = botao;
        this.appendChild(botao);
      }

      alternarTelaCheia(video) {
        if (this.estaEmTelaCheia()) {
          this.sairTelaCheia();
          return;
        }

        if (typeof video.webkitEnterFullscreen === 'function') {
          video.webkitEnterFullscreen();
          return;
        }

        const alvo = this.deferred;
        if (alvo.requestFullscreen) {
          alvo.requestFullscreen();
        } else if (video.requestFullscreen) {
          video.requestFullscreen();
        }
      }

      sairTelaCheia() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }

      estaEmTelaCheia() {
        const ativo = document.fullscreenElement || document.webkitFullscreenElement;
        return ativo === this.deferred || ativo === this.deferred.querySelector('video');
      }

      sincronizarTelaCheia() {
        if (!this.botaoTelaCheia) return;

        const emTelaCheia = this.estaEmTelaCheia();
        this.botaoTelaCheia.setAttribute('aria-label', emTelaCheia ? this.rotuloSair : this.rotuloTelaCheia);
        this.botaoTelaCheia.classList.toggle('videos-br__tela-cheia--ativo', emTelaCheia);

        this.botaoTelaCheia
          .querySelector('.videos-br__tela-cheia-icone--entrar')
          ?.classList.toggle('hidden', emTelaCheia);
        this.botaoTelaCheia
          .querySelector('.videos-br__tela-cheia-icone--sair')
          ?.classList.toggle('hidden', !emTelaCheia);
      }
    }
  );
}
